import { render, staticRenderFns } from "./EventDetailsModal.vue?vue&type=template&id=4a6f9f90&scoped=true&"
import script from "./EventDetailsModal.vue?vue&type=script&lang=js&"
export * from "./EventDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./EventDetailsModal.vue?vue&type=style&index=0&id=4a6f9f90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6f9f90",
  null
  
)

export default component.exports